import { gql } from "@apollo/client";

export const AGREEMENTS = gql`
  query agreements($offset: Int, $first: Int, $typeOf: String) {
    agreements(offset: $offset, first: $first, typeOf: $typeOf) {
      totalCount
      edges {
        node {
          typeOf
          data
          objectId
        }
      }
    }
  }
`;
